__turbopack_context__.v({
  "slider": "oi8aiW_slider",
});
